<template>

  <div>

    <b-card
      no-body
    >
      <b-card-body>
        <b-card-title>Pedido</b-card-title>

        <app-collapse
          type="border"
          class="mt-2"
        >

          <app-collapse-item title="Información suministrada por el odontólogo">

            <b-row class="mt-2">
              <b-col>
                <b-media
                  class="mb-2"
                  no-body
                >
                  <b-media-aside class="mr-1">
                    <b-avatar
                      rounded
                      variant="light-primary"
                      size="34"
                    >
                      <feather-icon
                        icon="PaperclipIcon"
                        size="18"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="mb-0">
                      RX panorámica
                    </h6>
                    <small v-if="planningOrder.order.images">
                      <b-button
                        variant="link"
                        size="sm"
                        @click="viewDocument(planningOrder.order.images, 'RX panorámica', 'rx_panorama')"
                      >Ver panorámica</b-button>
                    </small>
                  </b-media-body>

                </b-media>
              </b-col>
              <b-col>
                <b-media
                  class="mb-2"
                  no-body
                >
                  <b-media-aside class="mr-1">
                    <b-avatar
                      rounded
                      variant="light-primary"
                      size="34"
                    >
                      <feather-icon
                        icon="PaperclipIcon"
                        size="18"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="mb-0">
                      Fotos intraorales
                    </h6>
                    <small v-if="planningOrder.order.images">
                      <b-button
                        variant="link"
                        size="sm"
                        @click="viewDocument(planningOrder.order.images, 'Fotos intraorales', 'intraoral_photos')"
                      >Ver fotos intraorales</b-button>
                    </small>
                  </b-media-body>

                </b-media>
              </b-col>
              <b-col>
                <b-media
                  class="mb-2"
                  no-body
                >
                  <b-media-aside class="mr-1">
                    <b-avatar
                      rounded
                      variant="light-primary"
                      size="34"
                    >
                      <feather-icon
                        icon="DownloadIcon"
                        size="18"
                      />
                    </b-avatar>
                  </b-media-aside>
                  <b-media-body>
                    <h6 class="mb-0">
                      Escaneo intraoral
                    </h6>
                    <small v-if="planningOrder.order.intraoral_scan_url">
                      <b-button
                        variant="link"
                        size="sm"
                        @click="viewDocument(planningOrder.order.intraoral_scan_full_url, 'Escaneo intraoral', 'download')"
                      >Descargar escaneo intraoral</b-button>
                    </small>
                  </b-media-body>

                </b-media>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                cols="12"
                md="12"
                lg="6"
              >
                <b-alert
                  variant="secondary"
                  show
                >
                  <h4 class="alert-heading">
                    Hallazgos
                  </h4>
                  <div class="alert-body">
                    <span>{{ planningOrder.order.findings }}</span>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                cols="12"
                md="12"
                lg="6"
              >
                <b-alert
                  variant="secondary"
                  show
                >
                  <h4 class="alert-heading">
                    Objetivos
                  </h4>
                  <div class="alert-body">
                    <span>{{ planningOrder.order.objectives }}</span>
                  </div>
                </b-alert>
              </b-col>
            </b-row>

          </app-collapse-item>

        </app-collapse>

        <b-card-title class="mt-2">
          Gestión planificador
        </b-card-title>

        <app-collapse
          type="border"
          class="mt-2"
        >
          <app-collapse-item title="Información gestionada por el planificador">

            <b-media
              class="mb-2"
              no-body
            >
              <b-media-aside class="mr-1">
                <b-avatar
                  rounded
                  :variant="planningOrder.planning_pdf ? 'light-primary' : 'light-secondary'"
                  size="34"
                >
                  <feather-icon
                    icon="PaperclipIcon"
                    size="18"
                  />
                </b-avatar>
              </b-media-aside>

              <b-media-body>
                <h6 class="mb-0">
                  Planificación (.pdf)
                </h6>
                <small v-if="planningOrder.planning_pdf">
                  <b-button
                    variant="link"
                    size="sm"
                    @click="viewDocument(planningOrder.planning_pdf_full_url, 'Planificación (.pdf)', 'pdf')"
                  >Ver planificación</b-button>
                </small>
                <p v-if="planningOrder.number_upper_aligners || planningOrder.number_lower_aligners">
                  <b>Alineadores superiores: </b>{{ planningOrder.number_upper_aligners }} | <b>Alineadores inferiores: </b>{{ planningOrder.number_lower_aligners }}
                </p>

                <p><b>Fecha de aprobación: </b>{{ planningOrder.approval_date }}</p>

                <div v-if="planningOrder.fabrications.length > 0">

                  <hr class="mb-2">

                  <!--              <small>Alineadores a fabricar</small>-->
                  <div
                    v-for="(fabrication, index) in planningOrder.fabrications"
                    :key="index"
                    class="d-flex justify-content-between align-items-center mb-2"
                  >
                    <div>
                      <h6 class="text-muted font-weight-bolder">
                        Superiores
                      </h6>
                      <p class="mb-0">
                        {{ fabrication.upper_aligners }}
                      </p>
                    </div>
                    <div>
                      <h6 class="text-muted font-weight-bolder">
                        Inferiores
                      </h6>
                      <p class="mb-0">
                        {{ fabrication.lower_aligners }}
                      </p>
                    </div>
                    <div>
                      <h6 class="text-muted font-weight-bolder">
                        Estado
                      </h6>
                      <b-badge
                        class="profile-badge"
                        :variant="fabrication.is_fabricated ? 'light-primary' : 'light-warning'"
                      >
                        {{ fabrication.is_fabricated ? 'Fabricado' : 'Sin fabricar' }}
                      </b-badge>
                    </div>
                  </div>
                </div>

              </b-media-body>

              <div v-if="includes(userData.role_id, [1])">
                <b-button
                  v-if="!planningOrder.planning_pdf"
                  variant="info"
                  class="float-right"
                  size="sm"
                  @click="uploadDataPlanning('planning_pdf')"
                >
                  Editar / Agregar
                </b-button>
                <b-button
                  v-else
                  variant="danger"
                  class="float-right"
                  size="sm"
                  @click="confirmDelete('planning_pdf')"
                >
                  Eliminar
                </b-button>
              </div>

            </b-media>
            <b-media
              class="mb-2"
              no-body
            >
              <b-media-aside class="mr-1">
                <b-avatar
                  rounded
                  :variant="planningOrder.models ? 'light-primary' : 'light-secondary'"
                  size="34"
                >
                  <feather-icon
                    icon="DownloadIcon"
                    size="18"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                <h6 class="mb-0">
                  Modelos
                </h6>
                <small v-if="planningOrder.models">
                  <b-button
                    variant="link"
                    size="sm"
                    @click="viewDocument(planningOrder.models_full_url, 'Modelos', 'download')"
                  >Descargar modelos</b-button>
                </small>
              </b-media-body>

              <div v-if="includes(userData.role_id, [1])">
                <b-button
                  v-if="!planningOrder.models"
                  variant="info"
                  class="float-right"
                  size="sm"
                  @click="uploadDataPlanning('models')"
                >
                  Editar / Agregar
                </b-button>
                <b-button
                  v-else
                  variant="danger"
                  class="float-right"
                  size="sm"
                  @click="confirmDelete('models')"
                >
                  Eliminar
                </b-button>
              </div>

            </b-media>
            <b-media
              class="mb-2"
              no-body
            >
              <b-media-aside class="mr-1">
                <b-avatar
                  rounded
                  :variant="planningOrder.model_3d_url ? 'light-primary' : 'light-secondary'"
                  size="34"
                >
                  <feather-icon
                    icon="LinkIcon"
                    size="18"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                <h6 class="mb-0">
                  Plan de tratamiento
                </h6>
                <small v-if="planningOrder.model_3d_url">
                  <b-button
                    variant="link"
                    size="sm"
                    @click="viewDocument(planningOrder.model_3d_url, 'Plan de tratamiento', 'embedded')"
                  >Ver Plan de tratamiento</b-button>
                </small>
              </b-media-body>

              <div v-if="includes(userData.role_id, [1])">
                <b-button
                  v-if="!planningOrder.model_3d_url"
                  variant="info"
                  class="float-right"
                  size="sm"
                  @click="uploadDataPlanning('model_3d_url')"
                >
                  Editar / Agregar
                </b-button>
                <b-button
                  v-else
                  variant="danger"
                  class="float-right"
                  size="sm"
                  @click="confirmDelete('model_3d_url')"
                >
                  Eliminar
                </b-button>
              </div>

            </b-media>

            <b-row>
              <b-col
                cols="12"
                lg="12"
              >
                <b-alert
                  variant="secondary"
                  show
                >
                  <h4 class="alert-heading">
                    Observaciones
                  </h4>
                  <div class="alert-body">
                    <span>{{ planningOrder.observation ? planningOrder.observation : 'Sin observaciones' }}</span>
                  </div>
                </b-alert>

                <div v-if="includes(userData.role_id, [1])">
                  <b-button
                    variant="info"
                    class="float-right"
                    size="sm"
                    @click="uploadDataPlanning('observation')"
                  >
                    Agregar observación
                  </b-button>
                </div>

              </b-col>
            </b-row>

          </app-collapse-item>
        </app-collapse>

        <b-card-title class="mt-2">
          Gestión técnico
        </b-card-title>

        <div v-if="planningOrder.order_status_id == 4">

          <div v-if="!planningOrder.manufacturing && planningOrder.all_attachments_uploaded">
            <b-card-sub-title>Antes de continuar, selecciona el trabajo a realizar. Esto permitirá asignar esta fabricación a tu perfil.</b-card-sub-title>

            <validation-observer ref="selectWorkType">
              <b-form
                class="mt-2 mb-2"
                @submit.prevent="assignTechnician"
              >

                <b-row class="align-content-center">
                  <!--                  <b-col
                    cols="8"
                    class="align-content-center"
                  >
                    <b-form-group label="Tipo de trabajo">
                      <validation-provider
                        #default="{ errors }"
                        name="Tipo de trabajo"
                        rules="required"
                      >
                        <b-form-select
                          v-model="assignForm.work_type_id"
                          :state="errors.length > 0 ? false : null"
                          :options="workTypes"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>-->

                  <b-col
                    cols="4"
                    class="align-content-center"
                  >
                    <b-button
                      :disabled="loading"
                      :variant="loading ? 'secondary' : 'success'"
                      type="submit"
                    >
                      <b-spinner
                        v-if="loading"
                        small
                        class="mr-2"
                      />
                      {{ loading ? 'Asignando...' : 'Asignar y continuar' }}
                    </b-button>
                  </b-col>
                </b-row>

              </b-form>
            </validation-observer>
          </div>

          <div v-else>

            <div
              v-if="!planningOrder.all_attachments_uploaded"
              class="mt-2"
            >
              <b-alert
                variant="info"
                show
              >
                <h4 class="alert-heading">
                  Importante
                </h4>
                <div class="alert-body">
                  <span>Aún faltan algunos archivos por subir para poder continuar con la fabricación. Una vez todos los archivos estén completos en la planificación, este módulo se habilitará para continuar.</span>
                </div>
              </b-alert>
            </div>

            <!--            <div
              v-for="(fabrication, index) in planningOrder.fabrications"
              :key="index"
            >
              {{ fabrication }}

              <validation-observer ref="simpleRules">
                <b-form
                  class="mt-2 mb-2"
                  @submit.prevent="manufacturingFormSubmit"
                >

                  <b-form-group
                    label="Fabricar"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Fabricar"
                      rules="required"
                    >
                      <b-form-select
                        v-model="manufacturingForm.fabrication"
                        :state="errors.length > 0 ? false : null"
                        :options="formattedFabrications"
                        @change="onChangeFabrication"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group
                    label="Alineadores superiores fabricados"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Alineadores superiores fabricados"
                      rules="required"
                    >
                      <b-form-input
                        v-model="manufacturingForm.upper_aligners"
                        type="number"
                        placeholder="Ingresa la cantidad"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                  </b-form-group>

                  <b-form-group
                    label="Alineadores inferiores fabricados"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Alineadores inferiores fabricados"
                      rules="required"
                    >
                      <b-form-input
                        v-model="manufacturingForm.lower_aligners"
                        type="number"
                        placeholder="Ingresa la cantidad"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                  </b-form-group>

                  <b-form-group
                    label="Observaciones"
                  >
                    <b-form-textarea
                      v-model="manufacturingForm.observation"
                      placeholder="Escribe tus observaciones aquí..."
                      rows="4"
                    />

                  </b-form-group>

                  <b-form-group>
                    <b-button
                      :disabled="loading"
                      :variant="loading ? 'secondary' : 'success'"
                      type="submit"
                    >
                      <b-spinner
                        v-if="loading"
                        small
                        class="mr-2"
                      />
                      {{ loading ? 'Creando...' : 'Guardar' }}
                    </b-button>
                  </b-form-group>

                </b-form>
              </validation-observer>

            </div>
            <div />-->
          </div>

        </div>

        <div v-if="planningOrder.manufacturing && planningOrder.manufacturing.technician">

          <div
            v-for="(fabrication, index) in formattedFabrications"
            :key="fabrication.id"
            class="fabrication-item bg-light-secondary p-2 mb-2"
          >

            <b-badge
              class="profile-badge float-right"
              :variant="fabrication.is_fabricated ? 'primary' : 'warning'"
            >
              {{ fabrication.is_fabricated ? 'Fabricado' : 'Sin fabricar' }}
            </b-badge>
            <p><strong>Alineadores superiores:</strong> {{ fabrication.upper_range }}</p>
            <p><strong>Alineadores inferiores:</strong> {{ fabrication.lower_range }}</p>

            <b-row
              v-if="fabrication.is_fabricated"
              cols="2"
              class="mt-2"
            >
              <b-col>
                <b-media
                  class="mb-2"
                  no-body
                >
                  <b-media-body>
                    <h6 class="mb-0">
                      Técnico
                    </h6>
                    <small>
                      {{ planningOrder.manufacturing.technician.full_name }}
                    </small>
                  </b-media-body>

                </b-media>
              </b-col>

              <b-col>
                <b-media
                  class="mb-2"
                  no-body
                >
                  <b-media-body>
                    <h6 class="mb-0">
                      Tipo de trabajo
                    </h6>
                    <small>
                      {{ planningOrder.order.work_type.name }}
                    </small>
                  </b-media-body>

                </b-media>
              </b-col>

            </b-row>

            <!-- Campo de observación -->
            <b-form-group
              v-if="!fabrication.is_fabricated"
              label="Observaciones:"
            >
              <b-form-textarea
                v-model="manufacturingForm.observation"
                rows="2"
                placeholder="Agrega una observación..."
              />
            </b-form-group>

            <!-- Botón de guardar (solo si no está fabricado) -->
            <b-button
              v-if="!fabrication.is_fabricated"
              variant="success"
              @click="manufacturingFormSubmit(fabrication)"
            >
              Guardar
            </b-button>

          </div>

        </div>

        <div v-if="[1, 2].includes(userData.role_id)">
          <b-card-title class="mt-2">
            Gestión comercial
          </b-card-title>

          <div v-if="planningOrder.order_status_id == 5">
            <b-card-sub-title>Para avanzar con el proceso, haz clic en el botón y cambia el estado del pedido a "Transporte". Esto permitirá coordinar el envío y continuar con la siguiente etapa.</b-card-sub-title>
            <p class="mt-2">
              Revisa detenidamente toda la información de la planificación y la gestión técnica antes de realizar el envío, asegurándote de que las cantidades sean correctas. Si todo está en orden, haz clic en el botón <b>Cambiar estado</b>.
            </p>
            <b-button
              :disabled="loading"
              :variant="loading ? 'secondary' : 'success'"
              class="mt-2"
              @click.prevent="confirmOrderStatusChange(6)"
            >
              <b-spinner
                v-if="loading"
                small
                class="mr-2"
              />
              {{ loading ? 'Creando...' : 'Cambiar estado' }}
            </b-button>
          </div>

          <div v-if="planningOrder.order_status_id == 6">
            <b-card-sub-title>Una vez confirmada la <b>entrega</b>, haz clic en el botón para cambiar el estado del pedido a "Entregado" y finalizar el proceso correctamente.</b-card-sub-title>

            <b-button
              :disabled="loading"
              :variant="loading ? 'secondary' : 'success'"
              class="mt-2"
              @click.prevent="confirmOrderStatusChange(7)"
            >
              <b-spinner
                v-if="loading"
                small
                class="mr-2"
              />
              {{ loading ? 'Creando...' : 'Cambiar estado' }}
            </b-button>
          </div>

          <div v-if="planningOrder.order_status_id == 7">
            <b-card-sub-title>El pedido ha sido gestionado en su totalidad y no hay más acciones pendientes. ¡Gracias por completar el proceso!</b-card-sub-title>
          </div>

        </div>

        <hr class="my-2">

        <!--        <div v-if="[5, 6, 7].includes(planningOrder.order_status_id)">
          <b-button
            :disabled="loading"
            :variant="loading ? 'secondary' : 'info'"
            class="mt-2 float-right"
            :to="{name: 'admin-order-remission', params: { id: planningOrder.id } }"
          >
            <b-spinner
              v-if="loading"
              small
              class="mr-2"
            />
            {{ loading ? 'Creando...' : 'Ver remisión' }}
          </b-button>
        </div>-->

      </b-card-body>

    </b-card>

    <!-- modal management-->
    <b-modal
      v-model="managementModal"
      cancel-variant="outline-secondary"
      ok-title="Guardar"
      cancel-title="Cancelar"
      centered
      title="Gestionar planificación"
      @ok.prevent="submitForm"
    >
      <validation-observer ref="simpleRules">
        <b-form>
          <b-form-group
            v-if="typeUpload === 'planning_pdf'"
            label="Planificación PDF"
          >
            <validation-provider
              #default="{ errors }"
              name="Planificación PDF"
              rules="required"
            >
              <b-form-file
                v-model="form.planning_pdf"
                accept=".pdf"
                :state="errors.length > 0 ? false : null"
                @change="onFileChange($event, 'planning_pdf')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

          </b-form-group>

          <b-form-group
            v-if="typeUpload === 'models'"
            label="Modelos (.zip)"
          >
            <validation-provider
              #default="{ errors }"
              name="Modelos (.zip)"
              rules="required"
            >
              <b-form-file
                v-model="form.models"
                accept=".zip"
                :state="errors.length > 0 ? false : null"
                @change="onFileChange($event, 'models')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

          </b-form-group>

          <b-form-group
            v-if="typeUpload === 'model_3d_url'"
            label="Modelo 3D (URL)"
          >
            <validation-provider
              #default="{ errors }"
              name="Modelo 3D (URL)"
              rules="required"
            >
              <b-form-input
                v-model="form.model_3d_url"
                type="url"
                placeholder="https://example.com/model"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

          </b-form-group>

          <b-form-group
            v-if="typeUpload === 'observation'"
            label="Observaciones"
          >
            <validation-provider
              #default="{ errors }"
              name="Observaciones"
              rules="required"
            >
              <b-form-textarea
                v-model="form.observation"
                placeholder="Escribe tus observaciones aquí..."
                rows="4"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>

          </b-form-group>
        </b-form>
      </validation-observer>
    </b-modal>

    <b-modal
      v-model="viewImageModal"
      cancel-variant="outline-danger"
      ok-only
      ok-title="Cerrar"
      centered
      :title="title"
      size="lg"
    >
      <b-card>
        <b-img
          :src="urlDocument"
          fluid
        />
      </b-card>
    </b-modal>

    <b-modal
        v-model="viewCarrouselModal"
        cancel-variant="outline-danger"
        ok-only
        ok-title="Cerrar"
        centered
        :title="title"
        size="lg"
    >

      <p>Cantidad de imagenes: {{ imagesCarrousel.filter(img => img.type === type).length }}</p>

      <b-card>

        <b-carousel
            v-if="imagesCarrousel.length"
            :interval="0"
            controls
            indicators
            background="#fff"
            img-width="500"
            img-height="500"
            style="text-align: center;"
        >
          <b-carousel-slide
              v-for="(image, index) in imagesCarrousel.filter(img => img.type === type)"
              :key="index"
          >
            <template #img>
              <b-img
                  :src="image.full_url"
                  class="d-block mx-auto img-fit"
                  alt="Imagen RX"
                  fluid
              />
            </template>
          </b-carousel-slide>

        </b-carousel>
        <div
            v-else
            class="text-center text-muted py-5"
        >
          No hay imágenes disponibles.
        </div>
      </b-card>
    </b-modal>

    <b-modal
      v-model="viewPdfModal"
      cancel-variant="outline-danger"
      ok-only
      ok-title="Cerrar"
      centered
      :title="title"
      size="lg"
    >
      <b-card>
        <iframe
          :src="urlDocument"
          width="100%"
          height="600px"
          style="border: none;"
        />
      </b-card>
    </b-modal>

    <b-modal
      v-model="viewModelModal"
      cancel-variant="outline-danger"
      ok-only
      ok-title="Cerrar"
      centered
      size="xl"
      :title="title"
    >
      <b-card>
        <iframe
          :src="urlDocument"
          width="100%"
          height="500"
          frameborder="0"
          allowfullscreen
          class="mb-4"
        />

        <a
          :href="urlDocument"
          target="_blank"
        >Puedes verlo también aqui</a>

      </b-card>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BTable,
  BCardBody,
  BCardTitle,
  BCardSubTitle,
  BFormCheckbox,
  BMediaAside,
  BMedia,
  BAvatar,
  BMediaBody,
  BButton,
  BRow,
  BCol,
  BAlert,
  BForm,
  BModal,
  BFormTextarea,
  BFormGroup,
  BFormFile,
  BFormInput,
  BImg,
  BFormSelect,
  BSpinner,
  BDropdownItem,
  BBadge, BCarousel, BCarouselSlide,
} from 'bootstrap-vue'
import api from '@/plugin/axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import planningOrders from '@/views/admin/planning-orders/PlanningOrders.vue'
import { includes } from 'core-js/internals/array-includes'

import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

export default {
  components: {
    BCarouselSlide,
    BCarousel,
    BBadge,
    BDropdownItem,
    BSpinner,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
    BFormGroup,
    BFormTextarea,
    BModal,
    BForm,
    BRow,
    BCol,
    BAlert,
    BButton,
    BMediaBody,
    BAvatar,
    BMedia,
    BMediaAside,
    BCard,
    BTable,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BFormCheckbox,
    BFormFile,
    BFormInput,
    BImg,
  },
  props: {
    planningOrder: {
      type: Object,
      required: true,
    },
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      assignForm: {
        work_type_id: null,
      },
      manufacturingForm: {
        upper_aligners: null,
        lower_aligners: null,
        observation: '',
        fabrication: null,
      },
      loading: false,
      managementModal: false,
      deleteModal: false,
      viewImageModal: false,
      viewCarrouselModal: false,
      viewPdfModal: false,
      viewModelModal: false,
      urlDocument: '',
      title: '',
      type: '',
      typeUpload: '',
      imagesCarrousel: [],
      workTypes: [
        { value: 1, text: 'Planificación' },
        { value: 2, text: 'Refinamiento' },
      ],
    }
  },
  setup() {
  },
  computed: {
    formattedFabricationsBK() {
      return this.planningOrder.fabrications.map(fabrication => ({
        value: fabrication.id, // El valor que se enviará al formulario
        text: `Alineadores Sup: ${fabrication.upper_aligners}, Alineadores Inf: ${fabrication.lower_aligners}`,
      }))
    },
    formattedFabrications() {
      let upperStart = 0
      let lowerStart = 0

      return this.planningOrder.fabrications.map(fabrication => {
        const formattedItem = {
          ...fabrication,
          upper_range: `${upperStart} - ${fabrication.upper_aligners}`,
          lower_range: `${lowerStart} - ${fabrication.lower_aligners}`,
          observation: '', // Campo para la observación
        }

        // Actualizamos el siguiente punto de inicio
        upperStart = fabrication.upper_aligners + 1
        lowerStart = fabrication.lower_aligners + 1

        return formattedItem
      })
    },
  },
  methods: {
    includes,
    viewDocument(urlDocument, title, type) {
      this.urlDocument = urlDocument
      this.title = title
      this.type = type

      if (type === 'image') {
        this.viewImageModal = true
      } else if (type === 'rx_panorama' || type === 'intraoral_photos') {
        this.imagesCarrousel = urlDocument
        this.viewCarrouselModal = true
      } else if (type === 'pdf') {
        this.viewPdfModal = true
      } else if (type === 'embedded') {
        this.viewModelModal = true
      } else {
        // DOWNLOAD
        const fileUrl = urlDocument // Cambia esto por tu URL
        const link = document.createElement('a')
        link.href = fileUrl
        link.setAttribute('download', `${this.planningOrder.id}_${title}.zip`) // Nombre del archivo al descargar
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    uploadDataPlanning(typeUpload) {
      console.log(typeUpload)
      this.typeUpload = typeUpload
      this.managementModal = true
    },
    onFileChange(event, field) {
      this.form[field] = event.target.files[0]
      console.log(this.form[field])
    },
    submitForm() {
      const formData = new FormData()
      // eslint-disable-next-line guard-for-in
      for (const key in this.form) {
        const value = this.form[key]

        // Solo agregamos si el valor no es null, vacío o "null" como string
        if (value !== null && value !== undefined && value !== 'null' && value !== '') {
          formData.append(key, value)
        }
      }

      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          try {
            const response = await api.post(`/api/planning-orders/${this.planningOrder.id}`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            this.$bvToast.toast('Se ha actualizado la planificación del pedido con éxito', {
              title: '¡Satisfactoriamente!', // Título del toast
              variant: 'success', // Color del toast
              solid: true, // Hace que el toast no sea translúcido
              autoHideDelay: 5000, // Duración en milisegundos (opcional)
              appendToast: true, // Asegura que se muestre como el más reciente
            })

            this.$router.go(0)
          } catch (error) {
            console.log('loading', error)
            if (error.response && error.response.data.errors) {
              const messages = Object.values(error.response.data.errors).flat().join('\n')

              this.$bvToast.toast(messages, {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            } else {
              this.$bvToast.toast('Ocurrió un error inesperado', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            }
          } finally {
            this.loading = false
            this.managementModal = false
            this.form.planning_pdf = null
            this.form.models = null
            this.form.model_3d_url = ''
            this.form.observation = ''
          }
        }
      }).catch(err => {
        this.loading = false
        console.log('finally', this.order, err)

        const { errors } = this.$refs.simpleRules

        console.log('Errores:', errors)

        // Si quieres ver qué campo tiene el error
        for (const error of errors) {
          console.log(`Campo: ${error.field}, Error: ${error.msg}`)
        }
      })
    },
    async confirmDelete(type) {
      const confirmDelete = confirm('¿Estás seguro de que deseas eliminar este dato?')

      if (confirmDelete) {
        await this.deleteData(type)
      }
    },
    async deleteData(type) {
      try {
        const formData = new FormData()
        formData.append(type, 1)

        const response = await api.post(`/api/planning-orders/delete-data/${this.planningOrder.id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        if (response.status === 200) {
          this.$bvToast.toast('Se ha eliminado correctamente.', {
            title: '¡Eliminado!', // Título del toast
            variant: 'success', // Color del toast
            solid: true, // Hace que el toast no sea translúcido
            autoHideDelay: 5000, // Duración en milisegundos (opcional)
            appendToast: true, // Asegura que se muestre como el más reciente
          })
          this.$router.go(0)
        }
      } catch (error) {
        console.error('Error eliminando el dato:', error)
        alert('Hubo un error eliminando el dato.')
      }
    },
    assignTechnician() {
      this.loading = true
      this.$refs.selectWorkType.validate().then(async success => {
        if (success) {
          try {
            const response = await api.post(`/api/manufacturing-orders/assign/${this.planningOrder.id}`)
            this.$bvToast.toast('Se ha asignado correctamente el pedido de fabricación', {
              title: '¡Satisfactoriamente!', // Título del toast
              variant: 'success', // Color del toast
              solid: true, // Hace que el toast no sea translúcido
              autoHideDelay: 5000, // Duración en milisegundos (opcional)
              appendToast: true, // Asegura que se muestre como el más reciente
            })

            this.$router.go(0)
          } catch (error) {
            console.log('loading', error)
            if (error.response && error.response.data.errors) {
              const messages = Object.values(error.response.data.errors).flat().join('\n')

              this.$bvToast.toast(messages, {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            } else {
              this.$bvToast.toast('Ocurrió un error inesperado', {
                title: 'Error',
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              })
            }
          } finally {
            this.loading = false
          }
        }
      }).catch(err => {
        this.loading = false

        const { errors } = this.$refs.selectWorkType

        console.log('Errores:', errors)

        // Si quieres ver qué campo tiene el error
        for (const error of errors) {
          console.log(`Campo: ${error.field}, Error: ${error.msg}`)
        }
      })
    },
    async manufacturingFormSubmit(fabrication) {
      this.loading = true

      this.manufacturingForm.upper_aligners = fabrication.upper_aligners
      this.manufacturingForm.lower_aligners = fabrication.lower_aligners
      this.manufacturingForm.fabrication = fabrication.id

      try {
        const response = await api.post(`/api/manufacturing-orders/complete/${this.planningOrder.id}`, this.manufacturingForm)
        this.$bvToast.toast('Se ha guardado la información correctamente', {
          title: '¡Satisfactoriamente!', // Título del toast
          variant: 'success', // Color del toast
          solid: true, // Hace que el toast no sea translúcido
          autoHideDelay: 5000, // Duración en milisegundos (opcional)
          appendToast: true, // Asegura que se muestre como el más reciente
        })

        this.$router.push({ name: 'admin-manufacturing-orders' })
      } catch (error) {
        console.log('loading', error)
        if (error.response && error.response.data.errors) {
          const messages = Object.values(error.response.data.errors)
            .flat()
            .join('\n')

          this.$bvToast.toast(messages, {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        } else {
          this.$bvToast.toast('Ocurrió un error inesperado', {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        }
      } finally {
        this.loading = false
      }
    },
    async confirmOrderStatusChange(orderStatusId) {
      const confirmDelete = confirm('¿Estás seguro de cambiar el estado del pedido?')

      if (confirmDelete) {
        await this.changeOrderStatus(orderStatusId)
      }
    },
    async changeOrderStatus(orderStatusId) {
      this.loading = true

      try {
        const response = await api.post(`/api/manufacturing-orders/change-status/${this.planningOrder.id}`, { order_status_id: orderStatusId })
        this.$bvToast.toast('Se ha guardado la información correctamente', {
          title: '¡Satisfactoriamente!', // Título del toast
          variant: 'success', // Color del toast
          solid: true, // Hace que el toast no sea translúcido
          autoHideDelay: 5000, // Duración en milisegundos (opcional)
          appendToast: true, // Asegura que se muestre como el más reciente
        })

        this.$router.go(0)
      } catch (error) {
        console.log('loading', error)
        if (error.response && error.response.data.errors) {
          const messages = Object.values(error.response.data.errors)
            .flat()
            .join('\n')

          this.$bvToast.toast(messages, {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        } else {
          this.$bvToast.toast('Ocurrió un error inesperado', {
            title: 'Error',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          })
        }
      } finally {
        this.loading = false
      }
    },
    onChangeFabrication(selectedFabricationId) {
      // Buscar la fabricación seleccionada
      const selectedFabrication = this.planningOrder.fabrications.find(f => f.id === selectedFabricationId)

      console.log(selectedFabricationId)
      // Si se encuentra, asignar los valores automáticamente
      if (selectedFabrication) {
        console.log('entra')
        this.manufacturingForm.upper_aligners = selectedFabrication.upper_aligners
        this.manufacturingForm.lower_aligners = selectedFabrication.lower_aligners
      }
    },
  },
}
</script>

<style>
.carousel-control-prev,
.carousel-control-next {
  background-color: rgba(0, 0, 0, 0.4); /* Fondo oscuro semitransparente */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  top: 50%;
  transform: translateY(-50%);
}

.img-fit {
  max-height: 70vh; /* ajusta según tu necesidad */
  object-fit: contain;
}

</style>
